import { ChangeDetectorRef, Component, forwardRef, OnInit, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Router } from '@angular/router';
import { ReuseTabService } from '@delon/abc/reuse-tab';
import { _HttpClient } from '@delon/theme';
import { SelectInstantBaseComponent } from '../selectInstant-base';

@Component({
  selector: 'app-multi-msic-select',
  templateUrl: './multi-msic-select.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiMSICSelectComponent),
      multi: true
    }
  ]
})
export class MultiMSICSelectComponent
  extends SelectInstantBaseComponent
  implements OnInit
{
  NotShowInReport: boolean = false;

  constructor(
    http: _HttpClient,
    router: Router,
    cdr: ChangeDetectorRef,
    private resueTabService: ReuseTabService
  ) {
    super(http, cdr, router);
  }

  ngOnInit(): void {
    this.checkAddNewOptionInReportAccess();
  }

  getUrl(searchValue: string): string {
    let url = `api/MSICCodes/lookup?$top=20&$skip=0&$orderby=code asc`;
    if (searchValue) {
      const searchStr = searchValue.replaceAll("'", "''");
      url = `${url}&$filter=(contains(code, '${encodeURIComponent(
        searchStr
      )}') or contains(name,'${encodeURIComponent(searchStr)}'))`;
    }
    return url;
  }

  // set the location want to navigate
  jump(): string {
    return 'einv/einv-setting';
  }

  // set the param
  queryParam(): String {
    return 'MsicCode';
  }

  checkAddNewOptionInReportAccess(): boolean {
    let curUrl = this.resueTabService.curUrl.toLowerCase();

    if (curUrl.includes('report')) {
      this.NotShowInReport = true;
    } else {
      this.NotShowInReport = false;
    }

    return this.NotShowInReport;
  }
}